import { UploadStatus } from '../../constants';
import { Upload } from '../../interfaces/upload.interface';
import { PaginationMeta } from '../../interfaces/pagination.interface';

export interface SortState {
  field: string;
  direction: 'asc' | 'desc';
}

export interface UploadsStateModel {
  uploads: {
    [key: string]: Upload;
  };
  selectedUploadId: string | null;
  pagination: PaginationMeta | null;
  uploadsCount: number;
  loading: boolean;
  currentSort: SortState | null;
}

export class ListUploadsForAdmin {
  static readonly type = '[Uploads] List All';
  constructor(public payload: { q?: string; status?: string; limit?: number; page?: number }) {}
}

export class ListUploadsForOrganisation {
  static readonly type = '[Uploads] List';
  constructor(
    public payload: {
      organisationId: string;
      params: {
        id?: string;
        statusses?: UploadStatus[];
        projectId?: string;
        department?: string;
        q?: string;
        aanvraagSoort?: string;
        openEvs?: boolean;
        keepActive?: boolean;
        validFromStart?: string;
        validFromEnd?: string;
        page?: number;
        limit?: number;
        sortBy?: string;
        sortDirection?: 'asc' | 'desc';
      };
    }
  ) {}
}

export class GetUpload {
  static readonly type = '[Uploads] GET';
  constructor(public payload: { organisationId: string; uploadId: string }) {}
}

/** Fetches the upload only when it is not already present in state. */
export class EnsureUpload {
  static readonly type = '[Uploads] Ensure';
  constructor(public payload: { organisationId: string; uploadId: string }) {}
}
export class SetSelectedUploadId {
  static readonly type = '[Uploads] Set Selected';
  constructor(public payload: { uploadId: string }) {}
}

export class DeleteUpload {
  static readonly type = '[Uploads] Delete';
  constructor(public payload: { uploadId: string }) {}
}

export class DeleteRisicogrid {
  static readonly type = '[Uploads] DeleteRisicogrid';
  constructor(public payload: { uploadId: string }) {}
}

export class AssignUploadToProject {
  static readonly type = '[Uploads] AssignToProject';
  constructor(public payload: { uploadId: string; projectId: string | null }) {}
}

export class UpdateUpload {
  static readonly type = '[Uploads] UpdateUpload';
  constructor(public payload: { uploadId: string; uploadAttributes: Partial<Upload> & { fileIds?: string[] } }) {}
}
